import { render, staticRenderFns } from "./ItemTextFormatted.vue?vue&type=template&id=23871a54&scoped=true&"
import script from "./ItemTextFormatted.vue?vue&type=script&lang=js&"
export * from "./ItemTextFormatted.vue?vue&type=script&lang=js&"
import style0 from "./ItemTextFormatted.vue?vue&type=style&index=0&id=23871a54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23871a54",
  null
  
)

export default component.exports